// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCSCommunicationType } from './tCSCommunicationType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExtCardReplaceCardAdvancedRequestModel {
    'replacementDeliveryTypes'?: TCSCommunicationType;
    'memberNumber'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtCardReplaceCardAdvancedRequestModel>> = [
        {
            "name":     "replacementDeliveryTypes",
            "baseName": "replacementDeliveryTypes",
            "type":     "TCSCommunicationType"
        },
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ExtCardReplaceCardAdvancedRequestModel.attributeTypeMap;
    }
}
